import { z } from 'zod';
import { routeSchema } from './getRoutesSchema';
import { visitPlanSchema } from './getVisitPlansSchema';

export const routeTraderSite = z.object({
  id: z.string(),
  deleted: z.boolean(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  routeId: z.string(),
  route: routeSchema.optional(),
  traderSiteId: z.string(),
  traderSite: z
    .object({
      id: z.string(),
      code: z.string().optional(),
      name: z.string().optional(),
      address: z.string().optional(),
      city: z.string().optional(),
      zipCode: z.string().optional(),
    })
    .optional(),
  visitPlanId: z.string().optional(),
  visitPlan: visitPlanSchema.optional(),
  customerId: z.string(),
  customer: z.object({
    id: z.string(),
    code: z.string().optional(),
    profession: z.string().optional(),
  }),
  basicRoute: z.boolean(),
  sequence1: z.number().nullish(),
  sequence2: z.number().nullish(),
  sequence3: z.number().nullish(),
  sequence4: z.number().nullish(),
  sequence5: z.number().nullish(),
  sequence6: z.number().nullish(),
  sequence7: z.number().nullish(),
});

export const getRouteTraderSitesSchema = z.array(routeTraderSite);

export type GetRouteTraderSitesResponse = z.infer<typeof getRouteTraderSitesSchema>;
